/* eslint-disable */
import './App.css'
import './Style.css'
import { useState, useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/header'
import Footer from './components/footer'
import Page from './components/page'
import Home from './pages/home'
import Ceo from './pages/ceo'
import Vision from './pages/vision'
import Management from './pages/management'
import Map from './pages/map'
import Outline from './pages/outline'
import Work from './pages/work'
import Notice from './pages/notice'
import Talent from './pages/talent'
import Welfare from './pages/welfare'
import Employ from './pages/employ'
import Detail from './pages/detail'
export default function App(){
  let location = useLocation()
  let [menu] = useState([
    {
      name : '회사소개', url : '/intro', sub : [
        {name : 'CEO 인사말', url : '/intro/ceo'},
        {name : 'Vision', url : '/intro/vision'},
        {name : '윤리경영', url : '/intro/management'},
        {name : '찾아오시는 길', url : '/intro/map'},
      ]
    },
    {
      name : '사업소개', url : '/business', sub : [
        {name : '손해사정 개요', url : '/business/outline'},
        {name : '수행 업무', url : '/business/work'},
      ]
    },
    {
      name : '회사소식', url : '/company', sub : [
        {name : '공지사항', url : '/company/notice'},
      ]
    },
    {
      name : '인재채용', url : '/human', sub : [
        {name : '인재상', url : '/human/talent'},
        {name : '복리후생', url : '/human/welfare'},
        {name : '채용공고', url : '/human/employ'},
      ]
    }
  ])
  let [noticeList] = useState([
    {
      key : '0',
      classification : '공지사항',
      title : '㈜DX손해사정법인 홈페이지 오픈',
      content : `
        [메인라인 홈페이지 리뉴얼 오픈 안내]<br>
        <br>
        안녕하세요. DX손해사정 홈페이지가 새롭게<br>
        리뉴얼 오픈하였습니다!<br>
        <br>
        이번 리뉴얼 통해 DX손해사정의 더 나은<br>
        서비스와 다양한 제품 정보, 최신 소식을 더욱<br>
        편리하게 확인하실 수 있습니다.<br>
        <br>
        새롭게 단장한 홈페이지에서 다양한 콘텐츠와<br>
        소식을 만나보세요. 새로운 홈페이지로<br>
        여러분을 초대합니다.
      `,
      date : '2025-08-25',
      src : '/img/main_content_01.png'
    },
    {
      key : '1',
      classification : '회사소식',
      title : '손해사정 개요',
      content : `
        손해사정이란 발생한 보험사고의 원인과 피해내용, 그리고 손해의 내용과 정도, 범위에 대하여 확인하고, 보험의 목적에 해당되는지 여부와 손해액을 평가, 결정하고 보험금을 지급하는 업무를 총칭합니다. 손해사정업무는 보험사고의 접수, 계약사항 확인, 현장조사, 손해액 조사, 보험약관 관계법규 적용에 의한 면부책 판단, 보험금의 계산, 보험금 지급 후의 절차 등으로서 검증과 정산을 하는 업무를 말합니다.
      `,
      date : '2025-08-25',
      src : '/img/main_content_02.png'
    },
    {
      key : '2',
      classification : '회사소식',
      title : '손해사정 도입 목적',
      content : `
        손해사정제도는 보험사고 발생 시 손해액 및 보험금의 사정이 보험사업자에 의하여만 이루어질 경우 보험계약자, 피보험자, 보험수익자나 피해자 등의 권익이 침해될 수 있다는 우려에서 손해사정이라는 중립적인 위치에 있는 전문자격자가 사고원인과 피해내용 및 그로 인한 손해의 내용과 정도, 범위 등에 대하여 조사, 확인하는 손해사정업무를 담당하게 함으로써 객관적이고 공정하며 합리적인 보험금을 산출하기 위해 도입되었습니다.
      `,
      date : '2025-08-25',
      src : '/img/main_content_03.png'
    },
    {
      key : '3',
      classification : '공지사항',
      title : 'VISION',
      content : `
        ㈜DX손해사정법인은<br>
        혁신적인 IT 솔루션과의 결합을 통해<br>
        고객의 미래가치를 한단계 성장시킵니다.<br>
        <br>
        ㈜DX손해사정법인은<br>
        모두가 닮고 싶은 기업,<br>
        누구나 일하고 싶은 기업이 되겠습니다.<br>
        <br>
        ㈜DX손해사정법인은<br>
        끊임없이 성장하며<br>
        고객이 먼저 찾는 기업이 되겠습니다.
      `,
      date : '2025-08-25',
      src : '/img/main_content_04.png'
    },
  ])
  let [employList] = useState([
    // {key : '0', classification : '채용중', title : '채용공고 가', content : 'abc', date : '2025-08-25'},
    // {key : '1', classification : '채용마감', title : '채용공고 나', content : 'def', date : '2025-08-25'},
    // {key : '2', classification : '채용중', title : '채용공고 다', content : 'ghi', date : '2025-08-25'},
  ])
  let [isPageDrop, setIsPageDrop] = useState(false)
  let [scrollValue, setScrollValue] = useState(0)
  let [scrollUpDown, setScrollUpDown] = useState(null)
  useEffect(() => {
    let scrollFn = () => {
      let scrollWhat = window.scrollY
      if(scrollWhat > scrollValue){
        setScrollUpDown('down')
      }else if(scrollWhat < scrollValue){
        setScrollUpDown('up')
      }
      setScrollValue(scrollWhat)
    }
    window.addEventListener('scroll', scrollFn)
    return () => {
      window.removeEventListener('scroll', scrollFn)
    }
  }, [scrollValue])
  return (
    <div onClick={() => {setIsPageDrop(false)}}>
      <Header
        menu={menu}
        scrollValue={scrollValue}
        scrollUpDown={scrollUpDown}
      />
      {
        location.pathname != '/' && !location.pathname.includes('detail')
        ?
        <Page
          menu={
            location.pathname.split('/')[1] == 'intro' ?
            menu[0] :
            location.pathname.split('/')[1] == 'business' ?
            menu[1] :
            location.pathname.split('/')[1] == 'company' ?
            menu[2] :
            location.pathname.split('/')[1] == 'human' ?
            menu[3] : ''
          }
          pathname={location.pathname.split('/')[2]}
          isPageDrop={isPageDrop}
          setIsPageDrop={setIsPageDrop}
        />
        :
        ''
      }
      <Routes>
        <Route path="/" element={<Home noticeList={noticeList}/>}/>
        <Route path="/intro">
          <Route path="ceo" element={<Ceo/>}/>
          <Route path="vision" element={<Vision/>}/>
          <Route path="management" element={<Management/>}/>
          <Route path="map" element={<Map/>}/>
        </Route>
        <Route path="/business">
          <Route path="outline" element={<Outline/>}/>
          <Route path="work" element={<Work scrollUpDown={scrollUpDown}/>}/>
        </Route>
        <Route path="/company">
          <Route path="notice" element={<Notice noticeList={noticeList}/>}/>
        </Route>
        <Route path="/human">
          <Route path="talent" element={<Talent/>}/>
          <Route path="welfare" element={<Welfare/>}/>
          <Route path="employ" element={<Employ employList={employList}/>}/>
        </Route>
        <Route path="/detail/:id" element={<Detail noticeList={noticeList} employList={employList}/>}/>
        <Route path="*" element={<>404 page</>}/>
      </Routes>
      <Footer menu={menu}/>
    </div>
  )
}